import { LightningElement, track, api  } from 'lwc';

/* Example Usage
    Example 1 (Using all properties):
        HTML:
            // If **is-rtl="true"**  --> Toggler should be on right side of page 
            <x-slds-checkbox-toggle
                is-checked="true"
                is-rtl="true"
                value-on="Enabled"
                value-off="Disabled"
                label="Toggle Something"
                ontoggled={handleToggle}
            ><x-slds-checkbox-toggle>

        JS:
            // Handle the message in the parent
            handleToggle(message) {
                if (message.detail === 'on') {
                    this.handleOn();
                } else if (message.detail === 'off') {
                    this.handleOff() 
                }
            }

    Example 2 (Minimal Setup):
        HTML:
            // Disabled on load, valueOff=valueOn, No label, should be on left side of page
            <x-slds-checkbox-toggle
                value-on="Toggled"
                ontoggled={handleToggle}
            ><x-slds-checkbox-toggle>

        JS:
            // Handle the message in the parent
            handleToggle(message) { // ... same as above }
*/

export default class sldsCheckboxToggle extends LightningElement {
    static renderMode = 'light'; 
    @track _isChecked = false;

    @api valueOn;
    @api valueOff;
    @api label;

    @api // Add if is enabled true if is enabled by default
    set isChecked(val) {
        this._isDefaultEnabled = val && (val==="true" || val===true);
    }
    get isChecked() {
        return this._isDefaultEnabled;
    }

    @api // if true label is right of toggler (should be positioned right side of page)
    set isRtl(val) {
        this._isRtl = val && (val==="true" || val===true);
    }
    get isRtl() {
        return this._isRtl;
    }


    // Set the toggler to Right to left if <isRtl> is true
    renderedCallback() {
        if (this.isRtl) {
            const ctrlDiv = this.querySelector('[data-id="rtlController"]')
            if (ctrlDiv){
                ctrlDiv.setAttribute("dir", "rtl");
            }
        }
    }
    // Toggle on/off State --> notify parent
    handleChange(event) {   
        this._isChecked = !this._isChecked;

        // Notify parent if toggle is on or off
        const message = this._isChecked ? 'on' : 'off';

        this.dispatchEvent(new CustomEvent('toggled', { detail: message, bubbles: true } ));
        
    }


    // If no off value specified --> set the off value to the on value
    get localvalueOff() {
        return this.valueOff ? this.valueOff : this.valueOn;
    }
}